module.exports = __webpack_public_path__ + "images/4f3cc1b1c8aa70f9489c5dd7ba50dd56.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/diaryofanant-characters00.jpg
// module id = ./webpack/assets/img/diaryofanant-characters00.jpg
// module chunks = 0